import React from 'react'
import { useLocale } from 'src/lib/hooks/useLocal'
import { paymentMethodsUIConfigs } from 'src/assets/UIPreviewConfig'
import { PaymentMethodsUIConfigType, UIPreviewPaymentMethodType } from 'src/lib/types/uiPreview'
import Pill from '../skeletons/Pill'
import { ArrowRight, ChevronRight } from 'react-feather'

interface PreviewPaymentMethodsOffersProps {
  paymentMethods: UIPreviewPaymentMethodType[]
}

const PreviewPaymentMethodsOffers: React.FC<PreviewPaymentMethodsOffersProps> = ({ paymentMethods }) => {
  const { t } = useLocale()

  return (
    <div className='flex flex-col space-y-3 w-full'>
      <div className='font-semibold text-sm w-full text-coal-dark'>{t('payment_methods')}</div>
      <div className='flex flex-col space-y-3 w-full'>
        {paymentMethodsUIConfigs?.map((paymentMethodsUIConfig: PaymentMethodsUIConfigType) => {
          const LogoComponent = paymentMethodsUIConfig.icon
          const discountText = paymentMethods?.find(
            (paymentMethod: UIPreviewPaymentMethodType) => paymentMethod?.paymentMethod === paymentMethodsUIConfig?.type
          )?.discountText
          return (
            <div
              key={paymentMethodsUIConfig?.type}
              className='bg-white relative overflow-hidden h-[5.2rem] pl-3 pr-2 pt-5 pb-2.5 h rounded-2xl border flex w-full items-center '
            >
              <div className='flex flex-row justify-between w-full'>
                <div className='flex flex-row space-x-6'>
                  <div className='w-8 h-8'>
                    <LogoComponent color='#4D4D4D' size={48} logoComponent={LogoComponent} />
                  </div>
                  <div className='w-3/4 flex flex-col space-y-2'>
                    <span className='font-semibold text-sm w-full text-coal-dark'>{paymentMethodsUIConfig?.label}</span>
                    <Pill height={1} width={6} />
                  </div>
                </div>
                <div className='flex flex-row justify-end items-center space-x-2'>
                  <div className='w-1/4 flex flex-col justify-end items-end space-y-2'>
                    <Pill height={1} width={3} />
                    <Pill height={1} width={2} />
                  </div>
                  <ChevronRight className='w-6 h-6' />
                </div>
              </div>
              {paymentMethodsUIConfig?.type !== 'COD' && Boolean(discountText) && (
                <div
                  className='text-right absolute top-0 right-0 rounded-tr-xl rounded-bl-2xl px-3 py-1 text-xs font-semibold text-green-dark'
                  style={{
                    background: 'linear-gradient(90deg, rgba(44, 135, 74, 0.00) 20%, rgba(44, 135, 74, 0.20) 101.8%)'
                  }}
                >
                  {discountText}
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default PreviewPaymentMethodsOffers
